/**
 *  @class
 *  @function CollectionBlock
 */

if (!customElements.get('collection-block')) {
  class CollectionBlock extends HTMLElement {
    connectedCallback() {
      this.tags = Array.from(this.querySelectorAll('[data-tag]'));
      this.panels = Array.from(this.querySelectorAll('[data-panel]'));
      this.shopAll = this.querySelector('[data-shop-all]');

      this.tags.forEach((button) => {
        button.addEventListener('click', () => {
          // Clicking the active tag clears the filter.
          const isActive = button.getAttribute('aria-pressed') === 'true';
          this.select(isActive ? 'all' : button.dataset.tag);
        });
      });
    }

    select(handle) {
      let activePanel = null;

      this.panels.forEach((panel) => {
        const match = panel.dataset.panel === handle;
        panel.hidden = !match;
        if (match) activePanel = panel;
      });

      this.tags.forEach((button) => {
        button.setAttribute('aria-pressed', button.dataset.tag === handle ? 'true' : 'false');
      });

      if (this.shopAll && activePanel) {
        this.shopAll.href = activePanel.dataset.url;
      }
    }
  }
  customElements.define('collection-block', CollectionBlock);
}
